import { Button, Input, Tooltip } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AddComplementaryMaterialSection } from './AddComplementaryMaterialSection';
import { CountWrapper, InputWrapper, TitleWrapper, Wrapper } from './PageCofiguration.styles';

import { Icon } from '@/components/Icon';
import { useCourseDetail, useMutateCourses } from '@/store';

export const PageConfiguration = () => {
  const { t } = useTranslation('CourseTranslations');
  const { course } = useCourseDetail();
  const [value, setValue] = useState(course?.complementaryMaterial?.title ?? '');
  const { updateComplementaryMaterialTitle } = useMutateCourses();

  if (!course) return null;

  const handleUpdateTitle = () =>
    updateComplementaryMaterialTitle({
      courseId: course._id,
      title: value
    });

  return (
    <Wrapper>
      <InputWrapper>
        <TitleWrapper>
          <span>{t('COMPLEMENTARY_MATERIAL_TITLE')}</span>
          <Tooltip title={t('COMPLEMENTARY_MATERIAL_TOOLTIP')}>
            <Button type="link" size="small" icon={<Icon i="Information" />} />
          </Tooltip>
        </TitleWrapper>
        <Input
          suffix={
            <Button
              onClick={handleUpdateTitle}
              style={{ display: value.length > 0 ? '' : 'none' }}
              type="primary"
              size="small"
              icon={<Icon i="Save" />}
            />
          }
          value={value}
          onChange={e => setValue(e.target.value)}
          maxLength={30}
        />
        <CountWrapper>{`${value.length}/30`}</CountWrapper>
      </InputWrapper>
      <AddComplementaryMaterialSection />
    </Wrapper>
  );
};
